export default __webpack_public_path__ + "static/media/calender-icon.d03f94dd.svg";